import { render } from "./ShishaProducts.vue?vue&type=template&id=147fe486&ts=true"
import script from "./ShishaProducts.vue?vue&type=script&lang=ts"
export * from "./ShishaProducts.vue?vue&type=script&lang=ts"

import "./ShishaProducts.vue?vue&type=style&index=0&id=147fe486&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.21_vue@3.4.21_typescript@5.4.5__webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__